import React, { ReactElement, useEffect } from "react"
import { useRouter } from "next/router"
import { useProfileQuery, useCreateQuestionMutation } from "../../graphql/generated/graphql"
import { GET_PROFILE } from "../../graphql/queries/profile.graphql"
import { DateTime } from "luxon"
import ProfileComponent from "../../components/profile"
import { FourZeroFour } from "../../components/fourZeroFour"
import Loading from "../../components/loading"
const nextI18NextConfig = require("../../../next-i18next.config.js").i18n
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import { Events, registerEvent } from "../../analytics"
import { apolloClient } from "../../utils"
import { Layout } from "../../layouts/layout"
import { MetaProfile } from "../../components/profile/metaProfile"

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: "blocking",
  }
}

export async function getStaticProps(props: any) {
  const response = await apolloClient.query({
    query: GET_PROFILE,
    variables: {
      username: props.params.username,
      time: Math.round(DateTime.fromJSDate(new Date()).toUTC().toSeconds()),
    },
  })
  const profile = await response.data.Profile
  const metadata = profile && MetaProfile(profile)

  return {
    props: {
      ...response.data,
      ...(await serverSideTranslations(props.locale, undefined, nextI18NextConfig)),
      metadata: metadata,
    },
    revalidate: 60,
  }
}

export const ProfilePage = () => {
  const router = useRouter()

  let username = (router.query.username as string).toLowerCase()
  // bug fix for the use case a redirect to a bonsai  query parameters that are misinterpreted to being part of the username
  // eg https://joinbonsai.co/myusername?fbclid=PLfJndz0utgOOnpJQKU-0uA4wmQK76wOBp
  if (username.indexOf("?") > 0) {
    username = username.substring(0, username.indexOf("?"))
  }
  const {
    data: profileData,
    loading,
    error,
    refetch: refetchProfileData,
  } = useProfileQuery({
    variables: { username },
    fetchPolicy: "no-cache",
  })

  const profile = profileData?.Profile
  const [createQuestion] = useCreateQuestionMutation()

  useEffect(() => {
    registerEvent(Events.VisitedProfile)
  }, [])

  if (loading) {
    return <Loading />
  }

  if (!!error || !profile) {
    return <FourZeroFour />
  }

  const profileProps = {
    profileData,
    profile,
    createQuestion,
    refetchProfileData,
  }

  return <ProfileComponent {...profileProps} />
}

export default ProfilePage

ProfilePage.getLayout = function getLayout(page: ReactElement) {
  return Layout(page)
}
